<div class="container">
	<div class="lds">
		<div />
		<div />
		<div />
		<div />
	</div>
</div>

<style>
	.container {
		min-height: 20rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.lds {
		display: inline-block;
		position: relative;
		width: 8rem;
		height: 8rem;
	}

	.lds div {
		box-sizing: border-box;
		display: block;
		position: absolute;
		width: 6.4rem;
		height: 6.4rem;
		margin: 0.8rem;
		border: 0.8rem solid var(--white);
		border-radius: 50%;
		animation: lds 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
		border-color: var(--white) transparent transparent transparent;
	}

	.lds div:nth-child(1) {
		animation-delay: -0.45s;
	}

	.lds div:nth-child(2) {
		animation-delay: -0.3s;
	}

	.lds div:nth-child(3) {
		animation-delay: -0.15s;
	}

	@keyframes lds {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}
</style>
